import React, { useEffect, useMemo } from 'react';
import { ReactFlow, useNodesState, useEdgesState, useReactFlow } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import './style.scss';
import customEdge from './customEdge';
import CardNode from './nodes/CardNode';
import DotNode from './nodes/DotNode';
import { createInitialNodes } from './utils/flowNodes';
import { createInitialEdges } from './utils/flowEdges';
import { isWeb } from '../../../utils/utility';

const edgeTypes = { customEdge };
const nodeTypes = { card: CardNode, dot: DotNode };

const AirHvacFlowDiagram = ({ airDevices = [], hvacs = [], onDeleteHvac, fromManageHVACSystem }) => {
  const { fitView } = useReactFlow();

  const nodesData = useMemo(
    () => createInitialNodes(airDevices, hvacs, onDeleteHvac, fromManageHVACSystem),
    [airDevices, hvacs, onDeleteHvac]
  );

  const edgesData = useMemo(
    () => createInitialEdges(airDevices, hvacs),
    [airDevices, hvacs]
  );

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  useEffect(() => {
    setNodes(nodesData);
    setEdges(edgesData);

    setTimeout(() => {
      fitView({ padding: 0.2 });
    }, 0);

  }, [nodesData, edgesData, setNodes, setEdges, fitView]);

  const unlinkedHvacsCount = hvacs.filter(hv => !hv['linked-air-devices']?.length).length;
  const heightRows = airDevices.length + unlinkedHvacsCount;
  const wrapperHeight = `${heightRows * (isWeb() ? 140 :  75)}px`;

  return (
    <div className="xyflow-wrapper" style={{ height: wrapperHeight }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        fitView
        panOnDrag={false}
        zoomOnScroll={false}
        zoomOnDoubleClick={false}
        panOnScroll={false}
        zoomOnPinch={false}
        autoPanOnConnect={false}
        nodesConnectable={false}
        nodeExtent={[[0, 0], [550, 800]]}
      />
    </div>
  );
};

export default AirHvacFlowDiagram;
